import ResizeObserver from 'resize-observer-polyfill';

export default ({ observableSource, resizableDestination }) => {
  const relocateMap = () => {
    const rect = observableSource.getBoundingClientRect();
    resizableDestination.style.left = `${rect.width}px`;
  };

  const resizeObserver = new ResizeObserver(relocateMap);
  resizeObserver.observe(observableSource);

  return () => {
    resizableDestination.removeAttribute('style');
    resizeObserver.unobserve(observableSource);
  };
};
